import { useRef } from 'react';

import MessageCenterFooter from '../components/MessageCenterFooter';
import MessageCenterHeader from '../components/MessageCenterHeader';
import { TabPanelProvider } from '../components/TabPanel/context';
import MessageCenterContent from '../components/MessageCenterContent';

import DrawerScreenLayout from 'modules/common/components/RightDrawer/DrawerScreenLayout';
import ClearSearchGoBack from 'modules/IMC/common/IMCHeader/actions/ClearSearchGoBack';

function Home() {
    const containerRef = useRef(null);

    return (
        <TabPanelProvider initialTab="open">
            <DrawerScreenLayout
                containerRef={containerRef}
                id="message-center-tabpanel-openMessages"
                aria-labelledby="message-center-tab-openMessages">
                <MessageCenterHeader containerRef={containerRef} startAction={ClearSearchGoBack} />
                <MessageCenterContent />
                <MessageCenterFooter />
            </DrawerScreenLayout>
        </TabPanelProvider>
    );
}

export default Home;
